import React, { memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useGetBoats, BoatDataModal } from 'modules/boats';
import { BoatsActions, BoatsSelectors } from 'modules/boats/redux';
import { useModal } from 'modules/main';
import { Button } from 'modules/ui/components';
import { SettingsModal } from 'modules/settings';
import { StatusItem } from '../StatusItem';
import { Subtitle } from '../Subtitle';
import { BoatSelect, ButtonsContainer } from './styledComponents';

type Props = {
  addPadding: boolean;
};

const BoatSideMenuSectionUi: React.FC<Props> = ({ addPadding }) => {
  const dispatch = useDispatch();
  const [isBoatDataModalOpen, , openBoatDataModal, closeBoatDataModal] =
    useModal(false);
  const [isSettingsModalOpen, , openSettingsModal, closeSettingsModal] =
    useModal(false);
  const { boat } = useGetBoats();
  const boats = useSelector(BoatsSelectors.boatsList);
  const selectedBoatId = useSelector(BoatsSelectors.selectedBoatId);
  const pricingEnabled = process.env.REACT_APP_STRIPE_ENABLED === 'true';
  return (
    <>
      {isBoatDataModalOpen && (
        <BoatDataModal
          isOpen={isBoatDataModalOpen}
          closeModal={closeBoatDataModal}
        />
      )}
      {isSettingsModalOpen && (
        <SettingsModal
          isOpen={isSettingsModalOpen}
          closeModal={closeSettingsModal}
        />
      )}
      <Subtitle addTopPadding={addPadding}>{`Boat status (${
        boat ? boat.name : 'No boat'
      })`}</Subtitle>
      {pricingEnabled && boats.length > 1 && (
        <BoatSelect
          value={selectedBoatId ?? ''}
          onChange={(e): void => {
            dispatch(BoatsActions.setSelectedBoatId(Number(e.target.value)));
          }}
        >
          {boats.map((b) => (
            <option key={b.id} value={b.id}>
              {b.name}
            </option>
          ))}
        </BoatSelect>
      )}
      <StatusItem isOk={!!boat?.polarsFile} label="Polars" />
      <StatusItem isOk={!!boat?.sailsFile} label="Sail configuration table" />
      <StatusItem isOk={!!boat?.waveFile} label="Wave correction table" />
      <ButtonsContainer>
        <Button
          stretch
          isSecondary
          clickHandler={openBoatDataModal}
          label="Boat configuration"
        />
        <Button
          stretch
          isSecondary
          clickHandler={openSettingsModal}
          label="App settings"
        />
      </ButtonsContainer>
    </>
  );
};

export const BoatSideMenuSection = memo(BoatSideMenuSectionUi);
